import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useGetContentQuery } from '@/queries';

export const createQueryCacheKey = (endpoint, args) =>
  `${endpoint}(${JSON.stringify(args)})`;

export const useContentWithSSRProtection = ({ locale, pathname }) => {
  const key = useMemo(
    () => createQueryCacheKey('getContent', { locale, pathname }),
    [locale, pathname]
  );

  const ssrStatus = useSelector(
    (state) => state.content?.queries?.[key]?.status
  );

  const skip = ssrStatus === 'rejected';

  const result = useGetContentQuery({ locale, pathname }, { skip });

  return {
    ...result,
    isError: skip,
  };
};

export default useContentWithSSRProtection;
